import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPerson, fas } from "@fortawesome/free-solid-svg-icons";
import "./Sidebar.css";
import { Accordion } from "react-bootstrap";
import { Context } from "../../../utils/context";
import { Permission } from "../../../utils/permissions";
library.add(fas);

const Sidebar = ({ isOpen }) => {
  const [activeAccordionItem, setActiveAccordionItem] = useState("1");
  const { isAllow } = useContext(Context);
  const location = useLocation();
  const [, setHeaderText] = useState(location.pathname);

  useEffect(() => {
    setHeaderText(location.pathname);
  }, [location.pathname]);

  // Highlight the link that matches the current route (visual only).
  const isCurrent = (to) =>
    location.pathname === to || location.pathname.startsWith(`${to}/`);

  const handleAccordionClick = (itemKey) => {
    setActiveAccordionItem(itemKey);
  };

  return (
    <aside
      className={`sidebar ${isOpen ? "open" : "sidebar--collapsed"}`}
      aria-label="Primary"
    >
      <ul>
        {isAllow?.includes(Permission.Dashboard.TotalRegistration.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "1" ? "active" : ""}`}
            onClick={() => handleAccordionClick("1")}
          >
            <Link
              to="/dashboard"
              aria-current={isCurrent("/dashboard") ? "page" : undefined}
              className="link-body-emphasis"
              title="Dashboard"
            >
              <div className="icon-text" title="Setting">
                <FontAwesomeIcon icon="fa-solid fa-gauge" className="icon" />
                {isOpen && <p>Dashboard</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}

        {isAllow?.includes(Permission.AppSetup.List.name) ||
        isAllow?.includes(Permission.BankDetail.List.name) ||
        isAllow?.includes(Permission.Employee.List.name) ||
        isAllow?.includes(Permission.PnlTransaction.List.name) ||
        isAllow?.includes(Permission.PnlClient.List.name) ||
        isAllow?.includes(Permission.Calendar.List.name) ||
        isAllow?.includes(Permission.Role.List.name) ||
        isAllow?.includes(Permission.Investor.Edit.name) ||
        isAllow?.includes(Permission.Network.List.name) ||
        isAllow?.includes(Permission.Strategy.List.name) ? (
          <li className="sidebar-group">
            <Accordion>
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  <div className="icon-text">
                    <FontAwesomeIcon
                      icon={["fas", "credit-card"]}
                      className="icon me-2"
                    />
                    {isOpen ? (
                      <p>Setting</p>
                    ) : (
                      <span className="visually-hidden">Setting</span>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="list-unstyled">
                    {isAllow?.includes(Permission.AppSetup.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "9" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("9")}
                      >
                        <Link
                          to="/masters/app-setup"
                          aria-current={
                            isCurrent("/masters/app-setup") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="App SetUp"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-globe"
                            className="icon me-2"
                          />
                          {isOpen && <p>App SetUp</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.BankDetail.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "bank-detail" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("bank-detail")}
                      >
                        <Link
                          to="/masters/bank-detail"
                          aria-current={
                            isCurrent("/masters/bank-detail")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Bank Details"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-building-columns"
                            className="icon me-2"
                          />
                          {isOpen && <p>Bank Details</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {/* {isAllow?.includes(Permission.FAQ.List.name) ? (
                    <li
                      className={`setting ${
                        activeAccordionItem === "101" ? "active" : ""
                      }`}
                      onClick={() => handleAccordionClick("101")}
                    >
                      <Link to="/masters/banner" aria-current={isCurrent("/masters/banner") ? "page" : undefined} className="link-body-emphasis" title="Banner">
                        <FontAwesomeIcon
                          icon="fa-solid fa-user-doctor"
                          className="icon me-2"
                        />
                        {isOpen && <p>Banner</p>}
                      </Link>
                    </li>
                  ) : (
                    <></>
                  )} */}

                    {isAllow?.includes(Permission.Network.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "network" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("network")}
                      >
                        <Link
                          to="/masters/network"
                          aria-current={
                            isCurrent("/masters/network") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="Network"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-network-wired"
                            className="icon me-2"
                          />
                          {isOpen && <p>Network</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.Strategy.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "strategy" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("strategy")}
                      >
                        <Link
                          to="/masters/strategy"
                          aria-current={
                            isCurrent("/masters/strategy") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="Strategy"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-chart-line"
                            className="icon me-2"
                          />
                          {isOpen && <p>Strategy</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.Employee.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "12" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("12")}
                      >
                        <Link
                          to="/masters/employee"
                          aria-current={
                            isCurrent("/masters/employee") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="Employee"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-user-doctor"
                            className="icon me-2"
                          />
                          {isOpen && <p>Employee</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.Role.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "13" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("14")}
                      >
                        <Link
                          to="/masters/role"
                          aria-current={
                            isCurrent("/masters/role") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="Role"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-user-doctor"
                            className="icon me-2"
                          />
                          {isOpen && <p>Role</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.Role.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "Calendar" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("Calendar")}
                      >
                        <Link
                          to="/masters/calendar"
                          aria-current={
                            isCurrent("/masters/calendar") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="Calendar"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-network-wired"
                            className="icon me-2"
                          />
                          {isOpen && <p>Calendar</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>
        ) : (
          <></>
        )}
        {isAllow?.includes(Permission.InvestorLedger.List.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "2" ? "active" : ""}`}
            onClick={() => handleAccordionClick("2")}
          >
            <Link
              to="/investor"
              aria-current={isCurrent("/investor") ? "page" : undefined}
              className="link-body-emphasis"
              title="Investor"
            >
              <div className="icon-text" title="Tickets Management">
                <FontAwesomeIcon
                  icon="fa-solid fa-money-bill"
                  className="icon"
                />
                {isOpen && <p>Investor</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}
        {isAllow?.includes(Permission.InvestorLedger.List.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "3" ? "active" : ""}`}
            onClick={() => handleAccordionClick("3")}
          >
            <Link
              to="/investor-ledger"
              aria-current={isCurrent("/investor-ledger") ? "page" : undefined}
              className="link-body-emphasis"
              title="Investor Ledger"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon={faPerson} className="icon" />
                {isOpen && <p>Investor Ledger</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}

        {isAllow?.includes(Permission.AppOperations.List.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "4" ? "active" : ""}`}
            onClick={() => handleAccordionClick("4")}
          >
            <Link
              to="/operations-main"
              aria-current={isCurrent("/operations-main") ? "page" : undefined}
              className="link-body-emphasis"
              title="Operation"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-gear" className="icon" />
                {isOpen && <p>Operation</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}
        {isAllow?.includes(Permission.InwardPayment.InvestorList.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "5" ? "active" : ""}`}
            onClick={() => handleAccordionClick("5")}
          >
            <Link
              to="/inward"
              aria-current={isCurrent("/inward") ? "page" : undefined}
              className="link-body-emphasis"
              title="Inward Payment"
            >
              <div className="icon-text">
                <FontAwesomeIcon
                  icon="fa-solid fa-credit-card"
                  className="icon"
                />
                {isOpen && <p>Inward Payment</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}
        {isAllow?.includes(Permission.OutwardPayment.UsersList.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "6" ? "active" : ""}`}
            onClick={() => handleAccordionClick("6")}
          >
            <Link
              to="/outward"
              aria-current={isCurrent("/outward") ? "page" : undefined}
              className="link-body-emphasis"
              title="Outward Payment"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-outdent" className="icon" />
                {isOpen && <p>Outward Payment</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}
        {isAllow?.includes(Permission.OutwardPayment.UsersList.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "15" ? "active" : ""}`}
            onClick={() => handleAccordionClick("15")}
          >
            <Link
              to="/bulk-outward"
              aria-current={isCurrent("/bulk-outward") ? "page" : undefined}
              className="link-body-emphasis"
              title="Bulk Payments"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-outdent" className="icon" />
                {isOpen && <p>Bulk Payments</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}
        {/* {isAllow?.includes(Permission.OutwardPayment.UsersList.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "canceled" ? "active" : ""}`}
            onClick={() => handleAccordionClick("canceled")}
          >
            <Link
              to="/canceled"
              aria-current={isCurrent("/canceled") ? "page" : undefined}
              className="link-body-emphasis"
              title="Cancled Payment"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-outdent" className="icon" />
                {isOpen && <p>Cancled Payment</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )} */}
        {/* {isAllow?.includes(Permission.TransferPayment.List.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "10" ? "active" : ""}`}
            onClick={() => handleAccordionClick("10")}
          >
            <Link
              to="/transfer"
              aria-current={isCurrent("/transfer") ? "page" : undefined}
              className="link-body-emphasis"
              title="Transfer Payment"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-outdent" className="icon" />
                {isOpen && <p>Transfer Payment</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )} */}

        {isAllow?.includes(Permission.Notification.List.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "7" ? "active" : ""}`}
            onClick={() => handleAccordionClick("7")}
          >
            <Link
              to="/notification"
              aria-current={isCurrent("/notification") ? "page" : undefined}
              className="link-body-emphasis"
              title="Notification"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-bell" className="icon" />
                {isOpen && <p>Notification</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}

        {isAllow?.includes(Permission.Chats.List.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "16" ? "active" : ""}`}
            onClick={() => handleAccordionClick("16")}
          >
            <Link
              to="/chats"
              aria-current={isCurrent("/chats") ? "page" : undefined}
              className="link-body-emphasis"
              title="Chats"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-outdent" className="icon" />
                {isOpen && <p>Chats</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}

        {isAllow?.includes(Permission.RateUs.List.name) ? (
          <li
            className={`mb-1 ${activeAccordionItem === "8" ? "active" : ""}`}
            onClick={() => handleAccordionClick("8")}
          >
            <Link
              to="/rate-us"
              aria-current={isCurrent("/rate-us") ? "page" : undefined}
              className="link-body-emphasis"
              title="Rate Us"
            >
              <div className="icon-text">
                <FontAwesomeIcon icon="fa-solid fa-bell" className="icon" />
                {isOpen && <p>Rate Us</p>}
              </div>
            </Link>
          </li>
        ) : (
          <></>
        )}

        {/* Location */}

        {isAllow?.includes(Permission.Country.List.name) ||
        isAllow?.includes(Permission.State.List.name) ||
        isAllow?.includes(Permission.City.List.name) ? (
          <li className="sidebar-group">
            <Accordion>
              <Accordion.Item eventKey="location">
                <Accordion.Header>
                  <div className="icon-text">
                    <FontAwesomeIcon
                      icon="fa-solid fa-location-dot"
                      className="icon me-2"
                    />
                    {isOpen ? (
                      <p>Location</p>
                    ) : (
                      <span className="visually-hidden">Location</span>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="list-unstyled">
                    {isAllow?.includes(Permission.Country.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "country" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("country")}
                      >
                        <Link
                          to="/location/country"
                          aria-current={
                            isCurrent("/location/country") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="Country"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-globe"
                            className="icon me-2"
                          />
                          {isOpen && <p>Country</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.State.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "state" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("state")}
                      >
                        <Link
                          to="/location/state"
                          aria-current={
                            isCurrent("/location/state") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="State"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-map"
                            className="icon me-2"
                          />
                          {isOpen && <p>State</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.City.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "city" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("city")}
                      >
                        <Link
                          to="/location/city"
                          aria-current={
                            isCurrent("/location/city") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="City"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-city"
                            className="icon me-2"
                          />
                          {isOpen && <p>City</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>
        ) : (
          <></>
        )}

        {/* Information */}

        {isAllow?.includes(Permission.AboutBlueChart.List.name) ||
        isAllow?.includes(Permission.OurMissions.List.name) ||
        isAllow?.includes(Permission.LiquidityProviders.List.name) ||
        isAllow?.includes(Permission.Awards.List.name) ||
        isAllow?.includes(Permission.OurLocations.List.name) ||
        isAllow?.includes(Permission.Licence.List.name) ||
        isAllow?.includes(Permission.TermsAndCondition.List.name) ||
        isAllow?.includes(
          Permission.PrivacyPolicy.List.name ||
            isAllow?.includes(Permission.FAQ.List.name),
        ) ? (
          <li className="sidebar-group">
            <Accordion>
              <Accordion.Item eventKey="information">
                <Accordion.Header>
                  <div className="icon-text">
                    <FontAwesomeIcon
                      icon={["fas", "circle-info"]}
                      className="icon me-2"
                    />
                    {isOpen ? (
                      <p>Information</p>
                    ) : (
                      <span className="visually-hidden">Information</span>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="list-unstyled">
                    {isAllow?.includes(Permission.AboutBlueChart.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "about-bluechart"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => handleAccordionClick("about-bluechart")}
                      >
                        <Link
                          to="/information/about-bluechart"
                          aria-current={
                            isCurrent("/information/about-bluechart")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="About BlueChart"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-circle-info"
                            className="icon me-2"
                          />
                          {isOpen && <p>About BlueChart</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.OurMissions.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "our-missions" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("our-missions")}
                      >
                        <Link
                          to="/information/our-missions"
                          aria-current={
                            isCurrent("/information/our-missions")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Our Missions"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-bullseye"
                            className="icon me-2"
                          />
                          {isOpen && <p>Our Missions</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(
                      Permission.LiquidityProviders.List.name,
                    ) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "liquidity-providers"
                            ? "active"
                            : ""
                        }`}
                        onClick={() =>
                          handleAccordionClick("liquidity-providers")
                        }
                      >
                        <Link
                          to="/information/liquidity-providers"
                          aria-current={
                            isCurrent("/information/liquidity-providers")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Liquidity Providers"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-droplet"
                            className="icon me-2"
                          />
                          {isOpen && <p>Liquidity Providers</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.Awards.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "awards" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("awards")}
                      >
                        <Link
                          to="/information/awards"
                          aria-current={
                            isCurrent("/information/awards")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Awards"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-trophy"
                            className="icon me-2"
                          />
                          {isOpen && <p>Awards</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.OurLocations.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "our-locations"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => handleAccordionClick("our-locations")}
                      >
                        <Link
                          to="/information/our-locations"
                          aria-current={
                            isCurrent("/information/our-locations")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Our Locations"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-location-dot"
                            className="icon me-2"
                          />
                          {isOpen && <p>Our Locations</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.Licence.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "licence" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("licence")}
                      >
                        <Link
                          to="/information/licence"
                          aria-current={
                            isCurrent("/information/licence")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Licence"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-certificate"
                            className="icon me-2"
                          />
                          {isOpen && <p>Licence</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(
                      Permission.TermsAndCondition.List.name,
                    ) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "terms-condition"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => handleAccordionClick("terms-condition")}
                      >
                        <Link
                          to="/information/terms-condition"
                          aria-current={
                            isCurrent("/information/terms-condition")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Terms And Condition"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-file-contract"
                            className="icon me-2"
                          />
                          {isOpen && <p>Terms And Condition</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.PrivacyPolicy.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "privacy-policy"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => handleAccordionClick("privacy-policy")}
                      >
                        <Link
                          to="/information/privacy-policy"
                          aria-current={
                            isCurrent("/information/privacy-policy")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Privacy Policy"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-user-shield"
                            className="icon me-2"
                          />
                          {isOpen && <p>Privacy Policy</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {/* {isAllow?.includes(Permission.FAQ.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "102" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("102")}
                      >
                        <Link
                          to="/masters/faq-category"
                          aria-current={
                            isCurrent("/masters/faq-category")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="FAQ Category"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-user-doctor"
                            className="icon me-2"
                          />
                          {isOpen && <p>FAQ Category</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )} */}
                    {isAllow?.includes(Permission.FAQ.List.name) ? (
                      <li
                        className={`setting ${
                          activeAccordionItem === "10" ? "active" : ""
                        }`}
                        onClick={() => handleAccordionClick("10")}
                      >
                        <Link
                          to="/masters/faq"
                          aria-current={
                            isCurrent("/masters/faq") ? "page" : undefined
                          }
                          className="link-body-emphasis"
                          title="FAQ"
                        >
                          <FontAwesomeIcon
                            icon="fa-solid fa-user-doctor"
                            className="icon me-2"
                          />
                          {isOpen && <p>FAQ</p>}
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>
        ) : (
          <></>
        )}

        {/* Tickets Management */}

        {isAllow?.includes(Permission.Subject.List.name) ||
        isAllow?.includes(Permission.Subject.List.name) ? (
          <li className="sidebar-group">
            <Accordion>
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  <div className="icon-text">
                    <FontAwesomeIcon
                      icon={["fas", "credit-card"]}
                      className="icon me-2"
                    />
                    {isOpen ? (
                      <p>Tickets Management</p>
                    ) : (
                      <span className="visually-hidden">
                        Tickets Management
                      </span>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <ul className="list-unstyled">
                    {isAllow?.includes(Permission.Subject.List.name) ? (
                      <li
                        className={`mb-1 ${activeAccordionItem === "subjects" ? "active" : ""}`}
                        onClick={() => handleAccordionClick("subjects")}
                      >
                        <Link
                          to="/ticket-management/subjects"
                          aria-current={
                            isCurrent("/ticket-management/subjects")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Subjects"
                        >
                          <div className="icon-text">
                            <FontAwesomeIcon
                              icon="fa-solid fa-outdent"
                              className="icon"
                            />
                            {isOpen && <p>Subjects</p>}
                          </div>
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}

                    {isAllow?.includes(Permission.Tickets.List.name) ? (
                      <li
                        className={`mb-1 ${activeAccordionItem === "tickets" ? "active" : ""}`}
                        onClick={() => handleAccordionClick("tickets")}
                      >
                        <Link
                          to="/ticket-management/tickets"
                          aria-current={
                            isCurrent("/ticket-management/tickets")
                              ? "page"
                              : undefined
                          }
                          className="link-body-emphasis"
                          title="Tickets"
                        >
                          <div className="icon-text">
                            <FontAwesomeIcon
                              icon="fa-solid fa-outdent"
                              className="icon"
                            />
                            {isOpen && <p>Tickets</p>}
                          </div>
                        </Link>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </li>
        ) : (
          <></>
        )}
      </ul>
    </aside>
  );
};

export default Sidebar;
